const DEFAULT_BREAKPOINTS = {
  400: 1,
  600: 2,
  800: 3,
  1000: 4,
  1200: 5,
  1400: 6,
  1600: 7,
  1800: 8,
  2000: 9,
  9999: 10
};

export { DEFAULT_BREAKPOINTS };
